import React from 'react';
import {BulkActions} from '../components/BulkActions';
import {TableTransfers} from '../components/TableTransfers';
import {FindAgent} from '../components/FindAgent';
import {Warning} from '../components/Warning';
import {TopCards} from '../components/TopCards';
import {BulkActionsProvider} from '../contexts/BulkActionsContext';
import {TransfersByAgentProvider} from '../contexts/TransfersByAgentContext';
import {FindAgentProvider} from '../contexts/FindAgentContext';
import styles from './styles.module.scss';

export function TransfersByAgentPage() {
  return (
    <TransfersByAgentProvider>
      <div id={'transfersByAgent-list-card'} className={styles.body}>
        <FindAgentProvider>
          <FindAgent/>
        </FindAgentProvider>
        <Warning/>
        <TopCards/>
        <BulkActionsProvider>
          <BulkActions/>
        </BulkActionsProvider>
        <TableTransfers/>
      </div>
    </TransfersByAgentProvider>
  );
}
